import { ColorEnum } from '@/constants/color'
import type { AccountListStatus } from '@/features/openTabs/components/AccountList/parts/StatusTabs'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { createStyleSheet } from 'react-native-unistyles'

interface OverviewProps {
    status: AccountListStatus
    count: number
    total: string
}

const Overview: FC<OverviewProps> = ({ status, count, total }) => {
    const { t } = useTranslation('app')

    return (
        <View style={styles.container} testID="account-list-overview">
            <View style={styles.valueGroup}>
                <Typography.Menu style={styles.title}>
                    {t(`openTabs.accountList.overview.${status}`)}
                </Typography.Menu>
                <Typography.Menu style={styles.value}>{count}</Typography.Menu>
            </View>
            <View style={styles.valueGroup}>
                <Typography.Menu numberOfLines={1}>
                    {t('openTabs.accountList.overview.total')}
                </Typography.Menu>
                <Typography.Menu style={styles.value}>{total}</Typography.Menu>
            </View>
        </View>
    )
}

const styles = createStyleSheet({
    container: {
        minHeight: 20,
        paddingHorizontal: 16,
        alignItems: 'flex-start',
        gap: 8,
        backgroundColor: ColorEnum.WHITE,
    },
    title: {
        flexShrink: 1,
        textTransform: 'uppercase',
    },
    valueGroup: {
        flexDirection: 'row',
        alignItems: 'baseline',
        flexWrap: 'wrap',
        gap: 8,
    },
    value: {
        color: ColorEnum.EMERALD_700,
    },
})

export default Overview
